// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3aUJp","content":"styles_content__1-_Qg"};